var map = {
	"./css/font.css": "b277",
	"./css/fonts/lato/Lato-Black.ttf": "3f69",
	"./css/fonts/lato/Lato-Bold.ttf": "55ab",
	"./css/fonts/lato/Lato-Light.ttf": "48bc",
	"./css/fonts/lato/Lato-Regular.ttf": "10a0",
	"./css/fonts/lato/Lato-Thin.ttf": "5e53",
	"./css/fonts/lato/OFL.txt": "4ae2",
	"./css/main.css": "5aea",
	"./data/abstract_text": "8779",
	"./data/abstract_text.json": "8779",
	"./i-icon-white.svg": "8f20",
	"./i-icon.svg": "8080",
	"./nav-cards/C.png": "ebfb",
	"./nav-cards/C.svg": "6489",
	"./nav-cards/D.png": "9f97",
	"./nav-cards/D.svg": "020d",
	"./nav-cards/E.png": "4502",
	"./nav-cards/E.svg": "76c8",
	"./nav-cards/H.png": "5aef",
	"./nav-cards/H.svg": "3f03",
	"./nav-cards/M.png": "19cf",
	"./nav-cards/M.svg": "17a4",
	"./nav-cards/N.png": "bac0",
	"./nav-cards/N.svg": "5763",
	"./nav-cards/R.png": "9ab8",
	"./nav-cards/R.svg": "3bb1",
	"./nav-cards/S.png": "030c",
	"./nav-cards/S.svg": "d80d",
	"./nav-cards/broadgraphic.svg": "309a",
	"./nav-cards/precisegraphic.svg": "4f05",
	"./nav-cards/targetlocusmulti.png": "c557",
	"./nav-cards/targetlocussingle.png": "932d",
	"./tables/arch/Architectures_ALL.svg": "0223",
	"./tables/arch/Architectures_C.svg": "3bfb",
	"./tables/arch/Architectures_D.svg": "c6e7",
	"./tables/arch/Architectures_E.svg": "e0a3",
	"./tables/arch/Architectures_H.svg": "e031",
	"./tables/arch/Architectures_M.svg": "008b",
	"./tables/arch/Architectures_N.svg": "0171",
	"./tables/arch/Architectures_R.svg": "f506",
	"./tables/arch/Architectures_S.svg": "b0db",
	"./tables/cas9/Cas9variants_ALL.svg": "70bb",
	"./tables/cas9/Cas9variants_C.svg": "33cb",
	"./tables/cas9/Cas9variants_D.svg": "20ba",
	"./tables/cas9/Cas9variants_E.svg": "ecad",
	"./tables/cas9/Cas9variants_H.svg": "f57a",
	"./tables/cas9/Cas9variants_M.svg": "65ff",
	"./tables/cas9/Cas9variants_N.svg": "711f",
	"./tables/cas9/Cas9variants_R.svg": "189d",
	"./tables/cas9/Cas9variants_S.svg": "d897",
	"./tables/deam/Deaminasevariants_ALL.svg": "8554",
	"./tables/deam/Deaminasevariants_C.svg": "0899",
	"./tables/deam/Deaminasevariants_D.svg": "7acb",
	"./tables/deam/Deaminasevariants_E.svg": "8090",
	"./tables/deam/Deaminasevariants_H.svg": "bcdb",
	"./tables/deam/Deaminasevariants_M.svg": "e241",
	"./tables/deam/Deaminasevariants_N.svg": "b354",
	"./tables/deam/Deaminasevariants_R.svg": "bcaf",
	"./tables/deam/Deaminasevariants_S.svg": "8bdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";